import {GET_USER_BRANCHES, LOGIN, SELECT_BRANCH, SET_FEE, RESET_APP} from '../constants'

export const selectBranch=(data)=>{
    return {
        type: SELECT_BRANCH,
        data: data
    }
}

export const userLogin=(data)=>{
    return {
        type: LOGIN,
        data: data
    }
}


export const SetCardFee=(data)=>{
    return {
        type: SET_FEE,
        data: data
    }
}

export const getUserBranches=(data)=>{
    return {
        type: GET_USER_BRANCHES,
        data: data
    }
}

export const resetApp=(data)=>{
    return {
        type: RESET_APP,
        data: data
    }
}

